import { render, staticRenderFns } from "./episodeTable.vue?vue&type=template&id=bb2e331a"
import script from "./episodeTable.vue?vue&type=script&lang=js"
export * from "./episodeTable.vue?vue&type=script&lang=js"
import style0 from "./episodeTable.vue?vue&type=style&index=0&id=bb2e331a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports